import React, { useRef } from "react";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
import ZipModal from "@irati-web/payments/src/components/ZipModal";
var ZipReadMoreAndModal = function () {
    var readMoreModal = useRef(null);
    var handleReadMore = function () { return readMoreModal.current.show(); };
    return (React.createElement("div", null,
        React.createElement(Button, { cta: true, small: true, onClick: handleReadMore },
            React.createElement(FormattedMessage, { id: "platform.payments.zip.readMore" })),
        React.createElement(ZipModal, { ref: readMoreModal })));
};
export default ZipReadMoreAndModal;
